import { post } from '../apiCall';
const login = async function(email, password) {
        const userLoginResponse = await post('/users/login', { email, password });
        return userLoginResponse;
}
export default login;